import { createSelector } from 'reselect';
import { getReferenceDataCriteriaArguments } from '../../containers/base-filter-bar-container/reference-data-criteria-arguments';
import { staticCriteriaArguments } from './static-criteria-arguments';

export const getCriteriaArguments = createSelector(
  (state) => getReferenceDataCriteriaArguments(state),
  (referenceDataCriteriaArguments) => ({
    ...referenceDataCriteriaArguments,
    ...staticCriteriaArguments,
  }),
);
